import type {
    Price} from "@@/shared/prices/price";
import {
    legacyCustomerServiceFeePrice,
    zeroPrice,
} from "@@/shared/prices/price";
import { sumPrices } from "@@/shared/prices/sum-prices";
import type { OrderEvent } from "../../order-events/events/_order-event";
import type { OrderChangedEvent } from "../../order-events/events/order-changed-event/order-changed.event";
import type {
    OrderCreatedEvent} from "../../order-events/events/order-created.event";
import {
    isOrderCreatedEvent,
} from "../../order-events/events/order-created.event";

/**
 * # LEGACY FIX FOR ORDERS MADE BEFORE AUGUST 2021
 * If order is made before august 2021, and has no payment fulfilled or payment refund fulfilled events
 * and has a pending payment confirmation event followed by a pending confirmation event
 * then the order must have been paid.
 */
const legacyOrderPaidPrice = (
    initiatingEvent: OrderCreatedEvent | OrderChangedEvent,
    events: OrderEvent[],
):
    | {
          isLegacy: true;
          price: Price;
      }
    | {
          isLegacy: false;
          price: undefined;
      } => {
    if (!isOrderCreatedEvent(initiatingEvent)) {
        return { isLegacy: false, price: undefined };
    }

    const isLegacyOrder =
        initiatingEvent._createdAt.unix < 1627776000 && // Before 2021-08-01
        !events.some(e => e.type === "PAYMENT_FULFILLED"); // no payment fulfilled event

    if (!isLegacyOrder) {
        return { isLegacy: false, price: undefined };
    }

    // If the legacy order has a pending payment confirmation event followed
    // by a pending confirmation event, then the order must have been paid.
    const legacyPaid =
        events.some(e => e.type === "PENDING_PAYMENT_CONFIRMATION") &&
        events.some(e => e.type === "PENDING_CONFIRMATION");

    if (!legacyPaid) {
        return { isLegacy: false, price: undefined };
    }

    // and the original order price,
    // including any service fee
    const legacyOrderPrice = sumPrices([
        initiatingEvent.order.totalPrice,
        initiatingEvent.orderGroupHasLegacyServiceFee
            ? legacyCustomerServiceFeePrice
            : zeroPrice,
    ]);

    return { isLegacy: true, price: legacyOrderPrice };
};

export { legacyOrderPaidPrice };
